export type WindrawStatusTone =
  | 'neutral'
  | 'error'
  | 'planning'
  | 'production'
  | 'warehouse'
  | 'shipped'

const statusTones: Record<string, WindrawStatusTone> = {
  счет: 'neutral',
  'счет с ошибками': 'error',
  'допущен к планированию': 'planning',
  'в производстве': 'production',
  'на складе производства': 'warehouse',
  'отгружен со склада производства': 'shipped',
}

export const getWindrawStatusTone = (status?: string | null): WindrawStatusTone =>
  statusTones[
    String(status || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase()
  ] || 'neutral'
